import { render, staticRenderFns } from "./FeatureListTypography.vue?vue&type=template&id=7249391c&scoped=true"
import script from "./FeatureListTypography.vue?vue&type=script&lang=js"
export * from "./FeatureListTypography.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7249391c",
  null
  
)

export default component.exports